// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
export class PVT extends IndicatorScriptBase {
    constructor() {
        super();
        this.cummulativeDelta = 0;
        this.ProjectName = 'PVT';
        this.Comments = 'Price Volume Trend';
        super.SetIndicatorLine('pvt', Color.Blue, 1, LineStyle.SimpleChart);
        this.SeparateWindow = true;
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'PVT';
    }
    getCustomName() {
        return 'PVT (' + this.ProjectName + ')';
    }
    getPVT() {
        return (this.CurrentData.Volume(1) +
            (this.CurrentData.Volume() *
                (this.CurrentData.getPriceByType(PriceType.Close) -
                    this.CurrentData.getPriceByType(PriceType.Close, 1))) /
                this.CurrentData.getPriceByType(PriceType.Close, 1));
    }
    OnQuote() {
        super.OnQuote();
    }
    NextBar() {
        if (this.CurrentData.Count - 1 > 0) {
            const delta = this.getPVT() - this.CurrentData.Volume(1);
            this.cummulativeDelta += delta * 1000;
            super.SetValue(0, 0, this.cummulativeDelta / 1000);
        }
        super.NextBar();
    }
}
